import * as React from 'react';
import { Box, styled, TextField, Typography } from '@mui/material';
import { CSSProperties } from 'react';

interface FieldProps { 
  name: string;

  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  
  fieldStyle: CSSProperties;
  bodyBaseStyle: CSSProperties;
  
  autocomplete?: string;
  type?: React.InputHTMLAttributes<unknown>['type'];
  inputName?: string;

  multiline?: boolean;

  error?: boolean;
  errorMessage?: string;
}

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#154482',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#154482',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#154482',
      borderRadius: '2px',
    },
    '&:hover fieldset': {
      borderColor: '#154482',
      borderRadius: '2px',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#154482',
      borderRadius: '2px',
    },
  },
});

export default function Field(props: FieldProps) {
  const {
    name, 
    value, 
    onChange, 
    multiline = false, 
    error = false, 
    errorMessage,
    fieldStyle, 
    bodyBaseStyle, 
    autocomplete,
    type,
    inputName
  } = props;
  
  const fieldBoxStyle: CSSProperties = {
    display: 'flex',
    flexDirection: "column",
    flex: 1,
  }

  if (error) {
    delete fieldStyle.color;
  }

  return <Box style={fieldBoxStyle}>
    <Typography style={fieldStyle} color={error ? 'error' : undefined}>
      {`${name}${error && errorMessage ? ` - ${errorMessage}` : ''}`}
    </Typography>
    <CssTextField 
      multiline={multiline} 
      rows={4} 
      inputProps={{ style: bodyBaseStyle }}
      error={error}
      size='small'
      value={value}
      onChange={onChange}
      autoComplete={autocomplete}
      type={type}
      id={inputName}
      name={inputName}
      />
  </Box>;
}
